/**
 * 配信モードの決定（FR-DELIV-02 / FR-SRC-05）— 純関数。
 *
 * コンテンツごとの配信モードはサーバが決め、クライアントはマニフェストで自動追従する。
 * 明示指定（options.delivery）があっても、そのモードの成果物がマニフェストに無ければ
 * マニフェスト側を優先する — 表示できないモードを選ぶより、読めることを優先する
 * （engine/select.ts の「能力が無ければ降格する」方針と同じ）。
 *
 * プロバイダの生成は source/select.ts。ここは判断だけを持つ（判断は依存なしで検証できる）。
 */
import type { BookManifest } from '../core/manifest';

export type DeliveryKind = 'pdf' | 'image';
export type DeliveryOption = 'auto' | DeliveryKind;

export interface DeliveryChoice {
  kind: DeliveryKind;
  /** 要求と違うモードになった理由（自動追従は undefined）。 */
  reason?: 'no-image-assets' | 'no-pdf-url';
}

export function resolveDelivery(manifest: BookManifest, want: DeliveryOption): DeliveryChoice {
  const hasImage = manifest.urls.pages !== undefined && manifest.imaging !== undefined;
  const hasPdf = manifest.urls.pdf !== undefined;

  const wanted: DeliveryKind =
    want === 'auto' ? (manifest.deliveryMode === 'image' ? 'image' : 'pdf') : want;

  if (wanted === 'image' && !hasImage) return { kind: 'pdf', reason: 'no-image-assets' };
  if (wanted === 'pdf' && !hasPdf) return { kind: 'image', reason: 'no-pdf-url' };
  return { kind: wanted };
}
